export type ConversationPool = 'inbox' | 'labs'

export const CONVERSATION_POOL_PARAM = 'labs'

export const LABS_POOL_PARAM_VALUES = ['1', 'true'] as const

const LABS_VALUES: ReadonlySet<string> = new Set(LABS_POOL_PARAM_VALUES)

export function conversationPoolFromParam(value: string | null | undefined): ConversationPool {
  return LABS_VALUES.has((value ?? '').trim().toLowerCase()) ? 'labs' : 'inbox'
}

export function parseConversationPool(params: Pick<URLSearchParams, 'get'>): ConversationPool {
  return conversationPoolFromParam(params.get(CONVERSATION_POOL_PARAM))
}

export function applyConversationPoolToParams(params: URLSearchParams, pool?: ConversationPool) {
  if (pool === 'labs') {
    params.set(CONVERSATION_POOL_PARAM, '1')
  }
}
